import { createContext } from 'react';
import { ISubCategory } from 'types';

export type TSortBy =
	| ''
	| 'CustomerA-Z'
	| 'CustomerZ-A'
	| 'CategoriesA-Z'
	| 'CategoriesZ-A'
	| 'SubCategoriesA-Z'
	| 'SubCategoriesZ-A';
export type TCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error';
export interface IFilterValues {
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedCategory: Nullable<string>;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	subCategoryIsHidden: boolean;
	currentPage: number;
}

export interface ISubCategoryState {
	subCategories: ISubCategory;
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedCategory: Nullable<string>;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	subCategoryIsHidden: boolean;
	currentPage: number;
	IDForDeletion: string;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const subCategoryInitialState: ISubCategoryState = {
	subCategories: { subCategoriesCount: 0, subCategories: [] },
	searchString: '',
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	IDSelectedCategory: null,
	sortBy: '',
	countOfItems: '12',
	subCategoryIsHidden: false,
	currentPage: 1,
	IDForDeletion: '',
	typeOfModalWindow: null,
};

export interface ISubCategoryContext extends ISubCategoryState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	setIDCustomer(value: Nullable<string>): void;
	setIDRestaurant(value: Nullable<string>): void;
	setIDCategory(value: Nullable<string>): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TSortBy): void;
	setCountOfItems(count: TCountOfItems): void;
	toggleSubCategoryIsHidden(): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const SubCategoryContext = createContext<ISubCategoryContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setIDCategory: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	toggleSubCategoryIsHidden: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...subCategoryInitialState,
});
